import { RootState } from 'store';

import { STATE, IState } from '../types/state';

const selector = (state: RootState): IState['selectedCoordinates'] => {
  const { selectedCoordinates } = state[STATE];
  return selectedCoordinates;
};

export default selector;